/**
 * A single place to turn a raw stored status (order, delivery request,
 * payment) into the label a person reads — translatable, and no longer
 * duplicated between RequestsPage.js and DashboardPage.js.
 */
const STATUS_KEYS = {
  pending: 'status.pending',
  in_progress: 'status.inProgress',
  inprogress: 'status.inProgress',
  completed: 'status.completed',
  delivered: 'status.delivered',
  confirm: 'status.confirmed',
  confirmed: 'status.confirmed',
  accepted: 'status.accepted',
  picked: 'status.pickedUp',
  delivering: 'status.delivering',
  shipped: 'status.shipped',
  cancelled: 'status.cancelled',
  canceled: 'status.cancelled',
  processing: 'status.processing',
  paid: 'status.paid',
  unpaid: 'status.unpaid',
  failed: 'status.failed',
  refunded: 'status.refunded',
};

/** `t` is react-i18next's translation function; `status` the raw stored value. */
export function getStatusLabel(t, status) {
  const key = STATUS_KEYS[String(status || '').toLowerCase()];
  if (key) return t(key);
  if (!status) return '—';
  const s = String(status);
  return (s.charAt(0) || '').toUpperCase() + s.slice(1).replace(/_/g, ' ');
}
